<template>
  <v-form ref="couponForm" @submit.prevent="submitEventHandler">
    <v-card flat tile>
      <v-toolbar dark color="#002E4F" flat tile>
        <v-toolbar-title>Create Coupon</v-toolbar-title>
        <v-spacer />
        <v-btn icon @click="closeClickEventHandler">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-row>
          <v-col cols="12">
            <v-text-field
              v-model="name"
              class="base-input"
              label="Enter coupon name"
              :rules="[ rules.required ]"
              outlined
            />
          </v-col>
          <v-col cols="12" md="6">
            <v-select
              v-model="type"
              label="Type"
              class="base-input"
              :items="types"
              item-text="name"
              item-value="value"
              outlined
            />
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              v-model="code"
              class="base-input"
              label="Enter coupon code(6 digits)"
              :rules="[ rules.required, rules.counter ]"
              outlined
              counter
              maxlength="6"
            />
          </v-col>
          <v-col cols="12">
            <v-switch class="base-input" v-model="expiry" label="Add expiry date"></v-switch>
          </v-col>
          <v-col v-if="expiry" cols="12">
            <v-date-picker
              v-model="formattedDate"
              :landscape="true"
            />
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-row no-gutters>
          <v-col cols="12">
            <v-btn block dark color="#002E4F" type="submit">Create</v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
import { toRefs, reactive, defineComponent, watch, computed } from '@vue/composition-api';

export default defineComponent({
  name: 'CouponForm',

  props: {
    visibility: {
      type: Boolean
    }
  },

  setup(props, { refs, emit }) {
    const state = reactive({
      name: '',
      code: '',
      type: 0,
      expiry: false,
      date: new Date().toISOString(),
      rules: {
        required: value => !!value || 'Required.',
        counter: value => value && value.length <= 20 || 'Max 6 characters'
      },
      types: [
        {
          name: 'Month',
          value: 0
        },
        {
          name: '3 Month',
          value: 1
        },
        {
          name: 'Year',
          value: 2
        }
      ]
    });


    watch(() => props.visibility, (value) => {
      if (!value) {
        closeClickEventHandler();
      }
    });
    /**
     * Handler for the submit event
     * */
    function submitEventHandler() {
      const form = refs['couponForm'];
      if (form.validate()) {
        const payload = {
          name: state.name,
          code: state.code,
          type: state.type
        };

        if (state.expiry) {
          payload.expiryDate = state.date;
        }

        emit('save', payload);
      }
    }
    /**
     * Handler for the close click event
     * */
    function closeClickEventHandler() {
      emit('close');
      reset();
    }

    /**
     * Reset from data
     * */
    function reset() {
      state.name = '';
      state.code = '';
      state.type = 0;
      state.expiry = false;
      state.date = new Date().toISOString();
      const form = refs.couponForm;
      form.resetValidation();
    }

    const formattedDate = computed({
      get: () => new Date(state.date).toISOString().substr(0, 10),
      set: value => {
        state.date = new Date(value).toISOString();
      }
    });

    return {
      ...toRefs(state),
      formattedDate,
      submitEventHandler,
      closeClickEventHandler
    };
  }
});
</script>
